import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, IdCard } from 'lucide-react';
import logo from '../assets/logo.webp';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative overflow-hidden bg-[#0A192F] text-gray-300" data-testid="footer">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-20 left-12 h-40 w-40 rounded-full bg-[#64FFDA]/12 blur-3xl" />
        <div className="absolute right-16 top-10 h-48 w-48 rounded-full bg-[#64FFDA]/10 blur-3xl" />
        <div className="absolute bottom-0 left-1/3 h-32 w-32 rounded-full bg-[#64FFDA]/8 blur-3xl" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="flex items-center space-x-3 group flex-shrink-0">
               <img
                src={logo}
                alt="Connectify Logo"
                className="w-12 h-12 object-contain rounded-full transform group-hover:scale-110 transition-transform duration-300"
               />
              </div>
              <div className="flex flex-col items-end leading-tight text-right"> 
              <span className="bg-gradient-to-r from-white via-cyan-100 to-[#64FFDA] bg-clip-text text-xl font-black tracking-[0.14em] text-transparent drop-shadow-[0_6px_18px_rgba(100,255,218,0.18)]">
                CONNECTIFY
              </span>
              <span className="text-sm font-medium uppercase text-cyan-200/80 tracking-[0.42em]">
                IT SERVICES
                </span>
              </div>
            </div>
            <p className="text-sm">
              Trusted IT services for homes and businesses across multiple service regions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="inline-block transition-all duration-300 hover:text-[#64FFDA] hover:drop-shadow-[0_0_10px_rgba(100,255,218,0.45)] hover:translate-x-1" data-testid="footer-link-home">Home</Link>
              </li>
              <li>
                <Link to="/about" className="inline-block transition-all duration-300 hover:text-[#64FFDA] hover:drop-shadow-[0_0_10px_rgba(100,255,218,0.45)] hover:translate-x-1" data-testid="footer-link-about">About Us</Link>
              </li>
              <li>
                <Link to="/services" className="inline-block transition-all duration-300 hover:text-[#64FFDA] hover:drop-shadow-[0_0_10px_rgba(100,255,218,0.45)] hover:translate-x-1" data-testid="footer-link-services">Services</Link>
              </li>
              <li>
                <Link to="/booking" className="inline-block transition-all duration-300 hover:text-[#64FFDA] hover:drop-shadow-[0_0_10px_rgba(100,255,218,0.45)] hover:translate-x-1" data-testid="footer-link-booking">Book Service</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2 text-sm">
              <li>Networking Solutions</li>
              <li>IT Support</li>
              <li>Website Building</li>
              <li>Security Systems</li>
              <li>System Administration</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-end space-x-2">
                <MapPin className="w-5 h-5 text-[#64FFDA] flex-shrink-0 mt-0.5" />
                <span className="text-sm mt-0.5">Multiple cities across Australia</span>
              </li>
              <li className="flex items-end space-x-2">
                <Phone className="w-5 h-5 text-[#64FFDA] flex-shrink-0 mt-0.5" />
                <span className="text-sm mt-0.5">+61 452 225 995</span>
              </li>
              <li className="flex items-end space-x-2">
                <Mail className="w-5 h-5 text-[#64FFDA] flex-shrink-0 mt-0.5" />
                <span className="text-sm mt-0.5">info@connect-ify.com.au</span>
              </li>
              <li className="flex items-end space-x-2">
               <IdCard className="w-5 h-5 text-[#64FFDA] flex-shrink-0 mt-0.5" />
               <span className="text-sm mt-0.5">ABN: 30 672 391 657</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-center">
          <p className="text-sm">
            &copy; {currentYear} Connectify IT Services. All rights reserved.
          </p>
          <p className="text-xs mt-2 text-gray-500">
            Serving multiple cities with excellence in IT solutions
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
